<template>
    <div class="testimonial-view" v-loading="loading">
        <div class="row">
            <div class="col-md-12">

                <el-form ref="switchOption" :model="switchOption" label-width="150px" v-if="rights.switch">
                    <el-form-item label="Events :">
                        <el-switch
                            v-model="switchOption.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="Enable"
                            inactive-text="Disable"
                            @change= "changeDisplayStatus"
                            :disabled = "switchOption.disabled">
                        </el-switch>
                    </el-form-item>
                </el-form>

            </div>
        </div>

        <div class="row">

            <div class="col-md-4 mb-2">
                <el-button type="primary" @click="blukDelete" v-if="rights.delete">Bulk Delete</el-button>
                <el-button type="primary" @click="page.openDialog = true" v-if="rights.add">Add Event</el-button>

                <el-dialog
                    title="Event"
                    :visible.sync="page.openDialog"
                    width="90%"
                    :before-close="handleDialogClose"
                    v-loading="page.dialogLoding">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">

                                <el-form ref="eventsForm" :model="page.form" :rules="page.formRules" label-width="150px">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Image" prop="image">
                                                <div class="uploadDrag">
                                                    <input
                                                        type="file"
                                                        id="fileUpload"
                                                        ref="file"
                                                        name="file"
                                                        class="c-input u-sb-small"
                                                        @change="handleChange()">
                                                    <p id="fileUploadText">{{page.fileSelect}}</p>
                                                </div>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6 img-select" v-if="page.fileData != null">
                                            <div class="" style="width:100%; height:200px;">
                                                <img :src="page.fileData" class="selected-img">
                                                <div class="middle">
                                                    <div class="text" @click="handleRemove">Remove</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <el-form-item label="Name" prop="name">
                                        <el-input v-model="page.form.name" ref="name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Details" prop="details">
                                        <vue-editor v-model="page.form.details" :editorToolbar="customToolbar" ref="details"></vue-editor>
                                    </el-form-item>

                                    <el-form-item label="Date To" prop="date">
                                        <el-date-picker
                                            v-model="page.form.date"
                                            type="date"
                                            placeholder="Pick a day">
                                        </el-date-picker>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="submitData" v-if="page.formBtnSubmit">Submit</el-button>
                                        <el-button type="primary" @click="resetData('eventsForm')" v-if="page.formBtnSubmit">Reset</el-button>
                                        <el-button type="primary" @click="updateData" v-if="page.formBtnUpdate">Update</el-button>
                                    </el-form-item>

                                </el-form>

                            </div>
                        </div>

                    </span>
                </el-dialog>
            </div>

            <div class="col-md-4 mb-2">
            </div>

            <div class="col-md-4 mb-2">
                <el-input v-model="table.search" placeholder="Search By Name" v-if="rights.view" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="table.tableData.filter(data => !table.search || data.name.toLowerCase().includes(table.search.toLowerCase()))"
                    :default-sort = "{prop: 'name', order: 'descending'}"
                    style="width: 100%"
                    v-loading="table.loading"
                    @selection-change="handleSelectionChange"
                    v-if="rights.view">

                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>

                    <el-table-column label="Image" min-width="50"> 
                        <div slot-scope="{row}">
                            <img :src="row.image_path" alt="" style="width:100px;">
                        </div>
                    </el-table-column>

                    <!-- <el-table-column label="Image 2" prop="image"> </el-table-column> -->
                    <el-table-column label="Name" prop="name" sortable> </el-table-column>
                    <el-table-column label="Details" prop="details" sortable> </el-table-column>
                    <el-table-column label="Date" prop="date" sortable> </el-table-column>

                    <el-table-column
                        v-if="rights.edit || rights.delete"
                        align="right">
                        <template slot="header">
                            Action
                        </template>
                        <template slot-scope="scope">
                            <el-button
                            v-if="rights.edit"
                            size="mini"
                            @click="handleEditClick(scope.$index, scope.row)">Edit</el-button>
                            <el-button
                            v-if="rights.delete"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="pagination.perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader, handleFileType, handleFileSize} from "@/misc/function.js";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data () {

        const validName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Name'))
            } else {
                callback()
            }
        }

        const validDetails = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Details'))
            } else {
                callback()
            }
        }

        const validDate = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please select the Date'))
            } else {
                callback()
            }
        }

        const validImage = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Select File'))
            } else {
                callback()
            }
        }
        

        return {
            loading: false,
            fileError: false,
            customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
            rights: {
                page: true,
                view: false,
                add: false,
                edit: false,
                delete: false,
                bulk_delete: false,
                switch: false
            },
            switchOption: {
                disabled: false,
                status: true,
                cs_id: 0
            },
            page: {
                openDialog: false,
                dialogLoding: false,
                fileSelect: 'Drag your files here or click in this area.',
                fileData: null,
                form: {
                    e_id: 0,
                    name: '',
                    details: '',
                    date: '',
                    image: ''
                },
                formRules: {
                    name: [{ required: true, trigger: 'blur', validator: validName }],
                    details: [{ required: true, trigger: 'blur', validator: validDetails }],
                    date: [{ required: true, trigger: 'blur', validator: validDate }],
                    image: [{ required: true, trigger: 'blur', validator: validImage }]
                },
                formBtnSubmit: true,
                formBtnUpdate: false,
                formValid: false
            },
            table: {
                search: '',
                loading: false,
                multipleSelection: [],
                tableData: []
            },
            pagination: {
                currentPage: 1,
                perPageItem: 100,
                totalData: 0
            }
        }
    },
    methods: {
        // Image Change 
        handleChange() {
            this.page.form.image = this.$refs.file.files[0]
            if(handleFileSize(1393750 , this.page.form.image.size) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Size Too Large. Please Upload less then 1MB File !!!"
                });
            }
            var allowed_type = ['image/png' , 'image/jpg' , 'image/jpeg']
            if(handleFileType(allowed_type , this.page.form.image.type) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Type Invalid. Please Upload Only png , jpg or jpeg type !!!"
                });
            }
            
            if(!this.fileError){

                this.page.fileSelect = "File Selected"
                const input = this.$refs.file
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                        this.page.fileData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            }
            else{
                this.page.form.image = ""
                this.fileError = false
            }
        },
        handleRemove(){
            this.page.fileData = null,
            this.page.fileSelect = "Drag your files here or click in this area.",
            this.page.form.image = ''
        },
        //Dialog Close Event
        handleDialogClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                this.resetData('eventsForm')
                done();
            })
            .catch(_ => {});
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true
                }
                else{
                    this.page.formValid = false
                }
            });
        },
        //Page Size
        handleSizeChange(val) {
            this.pagination.perPageItem = val
            this.getData()
        },
        //Current Page
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getData()
        },
        //Multi Select
        handleSelectionChange(val){
            this.table.multipleSelection = val
        },
        convertDate(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        },
        //Single row Edit
        handleEditClick(index, row) {
            this.page.form.e_id = row.e_id
            this.page.form.name = row.name
            this.page.form.details = row.details
            this.page.form.date = row.date
            this.page.form.image = row.image
            this.page.fileData = row.image_path

            this.page.fileSelect = 'File Selected'
            
            

            this.page.formBtnSubmit = false
            this.page.formBtnUpdate = true

            this.page.openDialog = true
        },
        getRights() {
            this.loading = true
            this.$axios.post('events/rights.php' , {} , {
                headers: generateHeader("eventRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.event_page == 1 ? true : false
                    // Rights
                    this.rights.switch = response.data.body.rights.event_switch == 1 ? true : false
                    this.rights.add = response.data.body.rights.event_add == 1 ? true : false
                    this.rights.view = response.data.body.rights.event_view == 1 ? true : false
                    this.rights.edit = response.data.body.rights.event_edit == 1 ? true : false
                    this.rights.delete = response.data.body.rights.event_delete == 1 ? true : false
                    this.rights.bulk_delete = response.data.body.rights.event_bulk_delete == 1 ? true : false

                    // switchOption Value
                    this.switchOption.status = response.data.body.switchValue.status == 1 ? true : false
                    this.switchOption.cs_id = response.data.body.switchValue.cs_id

                    this.getData();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        getData() {
            this.table.loading = true
            this.$axios.post("events/get.php" , {
                pageSize: this.pagination.perPageItem,
                page: this.pagination.currentPage
            },{
                headers: generateHeader("eventsData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.table.tableData = response.data.body
                    this.pagination.totalData = parseInt(response.data.extra.totalData)
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.table.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.table.loading = false
            })
        },
        submitData(){
            this.handleFormValid("eventsForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                let formData = new FormData()
                formData.append('file', this.page.form.image)
                formData.append('name', this.page.form.name)
                formData.append('details', this.page.form.details)
                formData.append('date', this.convertDate(this.page.form.date))

                this.$axios.post("events/add.php",formData, {
                    headers: generateHeader("eventsAdd", true)
                })
                .then((response) => {
                    if(response.data.code == "201"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('eventsForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                   
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
            
        },
        updateData() {
            this.handleFormValid("eventsForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                let formData = new FormData()
                formData.append('file', this.page.form.image)
                formData.append('e_id', this.page.form.e_id)
                formData.append('name', this.page.form.name)
                formData.append('details', this.page.form.details)
                formData.append('date', this.convertDate(this.page.form.date))

                this.$axios.post("events/update.php", formData, {
                    headers: generateHeader("eventsEdit")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('eventsForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                    
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        //Single row Delete
        handleDelete(index, row) {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('events/delete.php' , {
                    id: row.e_id
                }, {
                    headers: generateHeader("eventsDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
            })
        },
        // Bluk Delete
        blukDelete() {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('events/bulk-delete.php' , {
                    data: this.table.multipleSelection
                }, {
                    headers: generateHeader("eventsBulkDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
                this.$notify.info({
                    title: 'Info',
                    message: "Delete Cancle !!!"
                });
            })
        },
        //Main Display
        //Content Display Setting using switch
        changeDisplayStatus(){
            this.$axios.post('events/displaySwitch.php' , {
                status: this.switchOption.status,
                cs_id: this.switchOption.cs_id
            }, {
                headers: generateHeader("eventsSwitch")
            })
            .then((response) => {
                if(response.data.code == "204"){
                    this.switchOption.disabled = true
                    setTimeout(() => this.switchOption.disabled = false, 1000);
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
            })
        },
        resetData(formName){
            // this.$refs[formName].resetFields();

            this.page.form.e_id = 0
            this.page.form.name = ''
            this.page.form.details = ''
            this.page.form.date = ''
            this.page.form.image = ''

            this.page.fileSelect = 'Drag your files here or click in this area.'
            this.page.fileData = null
            this.page.formBtnSubmit = true
            this.page.formBtnUpdate = false
            this.page.formValid = false
        }
    },
    mounted() {
        this.getRights()
    }
}

</script>


<style>
    .uploadDrag{
        /* position: absolute; */
        width: 100%;
        height: 200px;
        border: 4px dashed #000;
    }
    #fileUpload{
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
    }
    #fileUploadText{
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 170px;
        color: #000;
        font-family: Arial;
    }

    .selected-img{
        max-width: 100%;
        max-height: 100%;
        display: block;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }

    .middle {
        /* transition: .5s ease; */
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;

        background: #000;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
    }

    .img-select:hover .selected-img{
        opacity: 0.3;
    }

    .img-select:hover .middle{
        opacity: 1;
    }
</style>